$(function() {

    let $hotspot = $('[data-hotspot-toggle]')
    $hotspot.on('click', function(event) {
        event.preventDefault()
        let id = $(this).data('hotspot-toggle');
        $('[data-hotspot]').removeClass('is--active')
        $('[data-hotspot="'+id+'"]').addClass('is--active')
    })

    let $hotspotClose = $('[data-hotspot-close]')
    $hotspotClose.on('click', function(event) {
        event.preventDefault()
        $('[data-hotspot]').removeClass('is--active')
    })

})